<template>
  <div class="ivu-col ivu-col-span-18 tax-to-do index-module">
    <Row class="module-panel">
      <Row class="card-head" style="margin-bottom:0.5rem;">
        <Col span="4">{{modulename ? modulename : 待办任务 }}</Col>
        <Col span="8" style="float:right;">
          <Tabs :value="tabval" @on-click="handleTabsClick">
            <TabPane label="待处理" name="0"></TabPane>
            <TabPane label="待审核" name="1"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <Row class="module-panel-content" style="padding:0;">
        <Col span="14">
          <!-- -----------------任务列表----------------- -->
          <Table
            border
            height="240px"
            :data="data.data"
            :columns="columns"
            :loading="loading"
            @on-row-click="handleRowClick"
            :row-class-name="rowClassName"
          ></Table>
        </Col>
        <Col span="10" :style="{height: '243px', overflow: 'auto'}">
          <!-- ------------------任务流程-------------------- -->
          <Spin size="large" fix v-if="taskloading"></Spin>
          <!-- ------------------任务流程（图标）-------------------- -->
          <Col span="2" class="task-steps">
            <ul v-for="(item, index) in taskFlowList" :key="index">
              <li
                :class=" index == taskFlowList.length-1 ? 'task-circle' : 'task-circle task-circle-active'"
              ></li>
              <li v-if="index != taskFlowList.length-1 " class="task-line"></li>
            </ul>
          </Col>
          <Col span="22">
            <Col
              :style="{textAlign:'center',lineHeight:'238px',color:'#666',border:'1px solid #d6d2d2'}"
              v-show="taskFlowList.length == 0 ? true : false"
            >暂无数据</Col>
            <!-- ------------------任务流程（信息）-------------------- -->
            <Row
              :class=" index == taskFlowList.length-1 ? 'task-result' : 'task-result task-result-active'  "
              v-for="(item, index) in taskFlowList"
              :key="index"
            >
              <Col span="5" class="task-result-tit">
                <Tooltip
                  placement="bottom-start"
                  :content=" item.taskname ? item.taskname : '' "
                  class="task-tooltip"
                >{{ item.taskname ? item.taskname : '' }}</Tooltip>
              </Col>
              <Col span="10" :tooltip="true" class="task-result-content">
                <Tooltip
                  :disabled="item.taskassignee ? false : true"
                  placement="bottom-start"
                  :content=" item.taskassignee ? item.taskassignee +' '+ item.executetime : item.executetime "
                  class="task-tooltip"
                >{{ item.taskassignee ? item.taskassignee +' '+ item.executetime : item.executetime }}</Tooltip>
              </Col>
              <Col span="2"></Col>
              <Col span="6" class="task-result-right">
                <span v-if="index < taskFlowList.length-1  ? true : false">
                  已完成
                  <i class="ioss-checknumber"></i>
                </span>
                <span v-if="index == taskFlowList.length-1 ? true : false">
                  未完成
                  <i class="ioss-cross"></i>
                </span>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
      <Row style="margin:16px 13px 0 0;text-align:right;">
        <router-link to="./cas/index/task/list">查看全部：{{data.total}}</router-link>
      </Row>
    </Row>
  </div>
</template>
<script>
import { grade } from "@/assets/dict";
import { newformat } from "@/misc/utils";
export default {
  name: "TaxToDo",
  data() {
    return {
      /* tab控制 */
      tabval: 0,
      /* 任务列数据 */
      data: {
        data: [],
        total: 0
      },
      // 选中列标识
      rowflag: 0,
      /* 任务列选中后状态 */
      rowClassName: (row, index) => {
        if (index == this.rowflag) {
          return "demo-table-info-row";
        }
        return "";
      },
      // 流程加载状态
      taskloading: false,
      // 列加载状态
      loading: false,
      // 任务流程数据
      taskFlowList: [],
      // 列标题
      columns: [
        {
          title: "序号",
          key: "index",
          name: "index",
          fixed: "left",
          align: "center",
          minWidth: 65,
          render: (h, params) => {
            return h("div", params.index + 1);
          }
        },
        {
          title: "待办任务",
          key: "taskName",
          name: "taskName",
          fixed: "left",
          tooltip: true,
          width: 190,
          render: (h, params) => {
            if (params.index == 0) {
              this.indextaskExcetued(params.row.actId);
            }
            return h(
              "a",
              {
                props: {
                  size: "small"
                },
                attrs: {
                  href: "javascript:void(0);"
                },
                on: {
                  click: () => {
                    this.indextaskExcetued(params.row.actId);
                  }
                }
              },
              params.row.taskName
            );
          }
        },
        {
          title: "重要程度",
          key: "grade",
          tooltip: true,
          minWidth: 70
        },
        {
          title: "完成期限",
          key: "term",
          tooltip: true,
          minWidth: 140,
          render: (h, params) => {
            return h(
              "div",
              params.row.term
                ? newformat("yyyy-MM-dd", new Date(params.row.term))
                : ""
            );
          }
        }
      ]
    };
  },
  props: ["modulename"],
  methods: {
    /* 查询-待办任务 */
    indextaskExcetued(id) {
      this.taskloading = true;
      this.taskFlowList = [];
      const userCode = JSON.parse(localStorage.getItem("user")).code
        ? JSON.parse(localStorage.getItem("user")).code
        : JSON.parse(localStorage.getItem("user")).name;
      this.$api.declareCalenday
        .indextaskExcetued(userCode, id)
        .then(res => {
          if (res.data.result == "success" && res.data.data) {
            this.taskFlowList = res.data.data.tasks;
          }
          this.taskloading = false;
        })
        .catch(error => {
          this.taskloading = false;
        });
    },
    getlist() {
      this.loading = true;
      this.taskloading = true;
      const params = encodeURIComponent(JSON.stringify([]));
      const userCode = JSON.parse(localStorage.getItem("user")).code;
      const type = this.tabval == 0 ? "1" : "2";
      this.$api.declareCalenday
        .indextaskList(1, 5, params, userCode, type)
        .then(res => {
          if (res.data.result === "success" && res.data.data) {
            this.data = res.data.data;
            if (res.data.data.data.length == 0) {
              this.taskFlowList = [];
            }
          } else {
            this.taskFlowList = [];
          }
          this.taskloading = false;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.taskloading = false;
        });
    },
    handlerowClassName() {
      this.rowClassName = (row, index) => {
        if (index === this.rowflag) {
          return "demo-table-info-row";
        }
        return "";
      };
    },
    handleRowClick(data, i) {
      this.rowflag = i;
      this.handlerowClassName();
    },

    /* tab切换 */
    handleTabsClick(val) {
      this.tabval = val;
      this.getlist();
    }
  },
  mounted() {
    this.getlist();
  },
  activated() {
   this.getlist();
  }
};
</script>
